import styled from "styled-components";

import { responsiveFixedWidth } from "../styles/media";

export const BusinessProfileStyles = styled.section`
  width: 100%;
  min-height: 100vh;

  .editBusinesProfileCard {
    ${responsiveFixedWidth(852)}
  }
`;
